import { render } from "./ThreadUsersTableList.vue?vue&type=template&id=c99c5c3c&scoped=true"
import script from "./ThreadUsersTableList.vue?vue&type=script&lang=js"
export * from "./ThreadUsersTableList.vue?vue&type=script&lang=js"

import "./ThreadUsersTableList.vue?vue&type=style&index=0&id=c99c5c3c&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99c5c3c"]])

export default __exports__